<template>
  <div class="pointer list-item d-flex align-items-baseline" @click="$emit('click')">
    <div class="title flex-grow-1">{{ title }}&nbsp;</div>
    <div class="ml-2">
      <b-form-checkbox :checked="active" @change="$emit('click')" />
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

/**
 * This is the row item for initiative generated by AI.
 * It just shows initiative title and has a selection ability.
 */
export default {
  name: 'AIInitiativeRow',
  props: ['title', 'active'],
  components: {
    BFormCheckbox
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.list-item:hover {
  background-color: $senary;
}
.list-item:not(:first-child) {
  border-top: 1px solid $borderPrimary;
}
.list-item {
  padding: 12px 16px 12px 8px;
}
</style>
